import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * cn — Tailwind 클래스 병합 유틸리티
 *
 * clsx로 조건부 클래스를 합친 뒤 tailwind-merge로 중복/충돌 클래스를 정리한다.
 * (예: cn("px-2", isActive && "px-4") => "px-4")
 *
 * @example
 * cn("rounded border", isOpen && "bg-accent", className)
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
